module.exports = __webpack_public_path__ + "img/emitFacefilter04.48442e71.png";